<template>
    <create-ticket />
</template>

<script>
import CreateTicket from '@/modules/create-ticket';
export default {
    metaInfo: {
        title: 'Create Ticket',
    },
    components: {
        CreateTicket,
    },
};
</script>

<style lang="scss" scoped></style>
